/** Shared half-star review copy, matching the native review controls. */
export const ratingStrings = {
  rating: 'Rating',
  notRated: 'Not rated',
  clear: 'Clear rating',
  label: value => `Rate ${value} out of 5`,
  value: value => `${Number(value)} ${Number(value) === 1 ? 'star' : 'stars'}`,
};
